import React, { useEffect, useReducer, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import FormInput from './FormInput';
import EncabezadoAdmin from './EncabezadoAdmin';
import BtnGuardarEdit from './BtnGuardarEdit';
import { arreglarReloj, formatDateToInput, handleError, imprimirSeccion, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig';
import { ContainerAdmin } from './ContainerAdmin';
import cruzCierre from '../assets/cruzBlanca.png';
import { ContainerAdminN } from './ContainerAdminN';
import { EmpresasInvitadas } from './EmpresasInvitadas';
import SelectFiltrado from './SelectFiltrado';
import BadgesUsadas from './BadgesUsadas';
import { ImprimirMesasGafetes } from './ImprimirMesasGafetes';

const INITIAL_STATE = {
    horaFin: "17:00",
    horaInicio: "08:00",
    isEdit: false,
    esRondaNegocios: false,
    haveInvitedEnterprises: false,
    poseeBreak: false,
    mostrarReuniones: false,
    noMostrarSoloConcretadas: false,
    generarReuniones: false,
    permitirElegirHorario: false,
    poseeMesasReservadas: false,
    aproveEnterprises: false,
    isPaymentEvent: false,
    fecha: "2000-06-05",
    fechaCierreInscripcion: "2000-06-05",
    duracionReunion: "",
    duracionEntreReunion: "",
    tipoCupo: "Ilimitado",
    cantMesas: "",
    empresasInvitadas: [],
    cantMesasReservadas: "",
    nombre: "",
    cbu: "",
    price: "",
    whatsapp: "",
    restart: 0,
    isSetDate: 0,
    uniones: [],
    unionEliminada: {},
    reloadCount: 0,
    breaks: [{ horaInicio: "12:00", horaFin: "13:00" }],
    empresasInscriptas: [],
    cupo: "",
    direccion: '',
    typeAddress: 'Av. Mitre 4686, Caseros',
};

export const CrearEventoN = ({ evento, refresh, setNombreBuscar, setIdElemSeleccionado,
    setPerfil, nombreBuscar, show, updateHandlerRef, setSelectedCompany, setShowedModals, showedModals }) => {

    const eventoReducer = (state, action) => {
        switch (action.type) {

            case "RESET":
                return {
                    ...INITIAL_STATE,
                    restart: state.restart + 1,
                    reloadCount: state.reloadCount + 1
                };

            case "LOAD_EVENTO":
                return {
                    ...INITIAL_STATE,
                    ...action.payload,
                    isEdit: true
                };

            case "SET":
                return {
                    ...state,
                    [action.field]: action.value
                };

            case "SET_MANY":
                return {
                    ...state,
                    ...action.payload
                };

            case "ADD_BREAK":
                return {
                    ...state,
                    breaks: [...state.breaks, { horaInicio: "12:00", horaFin: "13:00" }]
                };

            case "REMOVE_BREAK":
                return {
                    ...state,
                    breaks: state.breaks.filter((_, i) => i !== action.index)
                };

            case "UPDATE_BREAK":
                return {
                    ...state,
                    breaks: state.breaks.map((b, i) =>
                        i === action.index ? { ...b, [action.field]: action.value } : b
                    )
                };

            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(eventoReducer, INITIAL_STATE);

    const agregarBreak = () => {
        dispatch({ type: "ADD_BREAK" });
    };

    const eliminarBreak = (index) => {
        dispatch({ type: "REMOVE_BREAK", index });
    };

    const actualizarBreak = (index, campo, valor) => {
        dispatch({
            type: "UPDATE_BREAK",
            index,
            field: campo,
            value: valor
        });
    };

    const setField = (field, value) => {
        dispatch({ type: "SET", field, value });
    };

    const setMany = (payload) => {
        dispatch({ type: "SET_MANY", payload });
    };

    const reset = () => {
        dispatch({ type: "RESET" });
        resetUI();
    };

    const resetUI = () => {
        document.getElementById("containerCrearScroll")?.scroll(0, 0);
        arreglarReloj();
    };

    useEffect(() => {
        if (!state.isEdit) {
            setField(
                "tipoCupo",
                state.esRondaNegocios ? "Doble de la cantidad de mesas" : "Ilimitado"
            );
        }
    }, [state.esRondaNegocios]);

    useEffect(() => {
        if (evento && evento.fecha) {
            setMany({
                isEdit: true,
                nombre: evento.nombre,
                horaInicio: evento.horaInicio,
                horaFin: evento.horaFin,
                uniones: evento.unionesLaborales?.map((label, index) => ({
                    label,
                    value: evento.unionLaboralNumber?.[index]
                })) || [],
                fecha: formatDateToInput(evento.fecha),
                fechaCierreInscripcion: formatDateToInput(
                    evento.fechaLimiteInscripcion || evento.fecha
                ),
                aproveEnterprises: evento.aprobarEmpresas || false,
                haveInvitedEnterprises: evento.esPrivado,
                isPaymentEvent: evento.esDePago || false,
                cbu: evento.cbu || "",
                price: evento.precio || "",
                whatsapp: evento.whatsapp || "",
                isSetDate: state.isSetDate + 1,
            });

            if (evento.permiteReuniones) {
                const poseeBreaks = evento.breaks?.length > 0;

                setMany({
                    esRondaNegocios: true,
                    poseeBreak: poseeBreaks,
                    breaks: poseeBreaks ? evento.breaks : INITIAL_STATE.breaks,
                    cantMesas: evento.cantidadDeMesas,
                    cantMesasReservadas: evento.cantidadDeMesasReservadas || 0,
                    poseeMesasReservadas: evento.poseeMesasReservadas || false,
                    duracionReunion: evento.duracionReunion,
                    duracionEntreReunion: evento.duracionEntreReuniones,
                    mostrarReuniones: evento.mostrarReuniones,
                    generarReuniones: evento.generarTurnos,
                    permitirElegirHorario: evento.permitirElegirHorario,
                    noMostrarSoloConcretadas: !evento.mostrarSoloConcretadas
                });
            }

            if (evento.cupoMaximo === -1) {
                setField("tipoCupo", "Ilimitado");
            } else if (
                evento.permiteReuniones &&
                evento.cupoMaximo === evento.cantidadDeMesas * 2
            ) {
                setField("tipoCupo", "Doble de la cantidad de mesas");
            } else {
                setMany({
                    cupo: evento.cupoMaximo,
                    tipoCupo: 'Ingrese su cupo'
                });
            }
            if (evento.direccion) {
                if (evento.direccion === 'Av. Mitre 4686, Caseros' || evento.direccion === 'Virtual') { 
                    setField("typeAddress", evento.direccion);
                } else {
                    setMany({
                        direccion: evento.direccion,
                        typeAddress: 'Otra'
                    });
                }
            }

            if (evento.esPrivado) {
                axios
                    .get(
                        process.env.REACT_APP_URL + "evento/listarEmpresasPermitidas",
                        { params: { eventoId: evento.id } }
                    )
                    .then(res => {
                        setField(
                            "empresasInvitadas",
                            res.data.map(e => ({ id: e.id }))
                        )
                    }
                    )
                    .catch(err => toastError(handleError(err)));
            }

            axios
                .get(
                    process.env.REACT_APP_URL + "empresa/verEmpresasDeUnEvento",
                    { params: { eventoId: evento.id } }
                )
                .then(res =>
                    setField(
                        "empresasInscriptas",
                        res.data.map(e => e.empresaPerfilFullView.nombre) || []
                    )
                )
                .catch(err => toastError(handleError(err)));

        } else if (evento && !evento.fecha) {
            reset();
        }
    }, [evento]);

    function duracionEvento(duracionReunion, duracionEntreReuniones, cantidadMesas) {
        const dr = Number(duracionReunion);
        const de = Number(duracionEntreReuniones);
        const m = Number(cantidadMesas);

        if (!dr || !m || dr < 0 || de < 0) return "0 horas";

        const total = (m * 2 - 1) * (dr + de) - de;
        if (total <= 0) return "0 horas";

        const h = Math.floor(total / 60);
        const min = total % 60;

        if (!h) return `${min} minutos`;
        if (!min) return h === 1 ? "1 hora" : `${h} horas`;

        return `${h}:${String(min).padStart(2, "0")} horas`;
    }

    const validarEvento = () => {
        if (!state.nombre) {
            markError("nombreEvento", "Debe completar el nombre del evento");
            return false;
        }

        if (state.horaInicio >= state.horaFin) {
            toastError("La hora de fin debe ser mayor a la hora de inicio");
            return false;
        }

        if (state.uniones.length === 0) {
            toastError("Debe seleccionar al menos una unión");
            return false;
        }

        if (state.esRondaNegocios) {
            if (!state.duracionReunion)
                return markError("duracionReunion", "Debe completar la duración de la reunión"), false;

            // 0 es válido: reuniones consecutivas sin pausa
            if (state.duracionEntreReunion === "" || state.duracionEntreReunion == null || Number(state.duracionEntreReunion) < 0)
                return markError("duracionEntreReunion", "Debe completar la duración entre reuniones"), false;

            if (!state.cantMesas)
                return markError("cantMesas", "Debe completar la cantidad de mesas"), false;

            if (state.cantMesasReservadas == null)
                return markError("cantMesasReservadas", "Debe completar la cantidad de mesas reservadas"), false;

            if (state.cantMesasReservadas > state.cantMesas) {
                toastError("No puede tener más mesas reservadas que las existentes")
                return false;
            }
        }

        if (state.poseeBreak) {
            for (const br of state.breaks) {
                if (br.horaInicio >= br.horaFin) {
                    toastError("La hora de fin del break debe ser mayor a la hora de inicio del break");
                    return false;
                }
                if (br.horaInicio < state.horaInicio || state.horaFin < br.horaFin) {
                    toastError("El break debe estar dentro del horario del evento");
                    return false;
                }
            }
        }

        if (state.tipoCupo === "Ingrese su cupo" && !state.cupo) {
            markError("cupo", "Debe ingresar el cupo del evento");
            return false;
        }
        if (state.typeAddress === "Otra" && !state.direccion) {
            markError("direccion", "Debe ingresar la dirección del evento");
            return false;
        }

        return true;
    };

    const input = id => document.getElementById(id);

    const markError = (id, msg) => {
        input(id)?.classList.add("texBoxError");
        toastError(msg);
    };

    const buildParams = () => {
        const cupo =
            state.tipoCupo === "Ingrese su cupo" ? state.cupo
                : state.tipoCupo === "Doble de la cantidad de mesas" ? Number(state.cantMesas) * 2
                    : -1;
        const address = state.typeAddress === "Otra" ? state.direccion : state.typeAddress;

        return {
            nombre: state.nombre,
            fecha: state.fecha,
            fechaLimiteInscripcion: state.fechaCierreInscripcion,
            horaInicio: state.horaInicio,
            horaFin: state.horaFin,
            cupoMaximo: cupo,
            direccion: address,
            unionesLaborales: state.uniones?.map(u => u.value) || [],
            duracionReunion: state.esRondaNegocios ? state.duracionReunion : 0,
            duracionEntreReuniones: state.esRondaNegocios ? state.duracionEntreReunion : 0,
            permiteReuniones: state.esRondaNegocios,
            mostrarReuniones: state.esRondaNegocios && state.mostrarReuniones,
            generarTurnos: state.esRondaNegocios && state.generarReuniones,
            permitirElegirHorario: state.esRondaNegocios && state.permitirElegirHorario,
            mostrarSoloConcretadas: state.esRondaNegocios ? !state.noMostrarSoloConcretadas : true,
            ...(state.esRondaNegocios && state.poseeBreak && { breaks: state.breaks }),
            ...(state.haveInvitedEnterprises ? { empresasPermitidas: state.empresasInvitadas, esPrivado: true } : { esPrivado: false }),
            aprobarEmpresas: state.aproveEnterprises,
            esDePago: state.isPaymentEvent,
            cbu: state.cbu,
            precio: state.price,
            whatsapp: state.whatsapp,
            ...(state.isEdit && { eventoId: evento?.id, poseeMesasReservadas: evento.poseeMesasReservadas })
        };
    };

    const crearEvento = () => {
        if (!validarEvento()) return;

        const params = buildParams();

        const request = state.isEdit
            ? axios.put(process.env.REACT_APP_URL + "evento", params)
            : axios.post(
                process.env.REACT_APP_URL +
                `evento?cantidadDeMesas=${state.esRondaNegocios ? state.cantMesas : 0}&cantidadDeMesasReservadas=${state.esRondaNegocios ? state.cantMesasReservadas : 0}`,
                params
            );

        request
            .then(() => {
                toastSuccess(state.isEdit ? "Evento actualizado" : "Evento creado");
                refresh();
                reset();
                cerrarCrearEvento();
            })
            .catch(err => toastError(handleError(err)));
    }

    function cerrarCrearEvento() {//VER
        setNombreBuscar('')
        //document.getElementById("buscarText").value = ''
        setShowedModals(prev => prev.slice(0, -1));
        /*document.getElementById("containerCrear").classList.remove("transform-none");
        document.getElementById("txt-nuevo-evento").classList.remove("d-none");
        document.getElementById("txt-cerrar").classList.add("d-none");
        document.getElementById("btnCrearEvento").classList.remove("bg-color-cerrar");*/

    }

    function mostrarInvitados() {//VER
        setNombreBuscar('')
        //document.getElementById("buscarText").value = ''
        setShowedModals(prev => [...prev, 'invited']);
        /*document.getElementById("containerInvitados").classList.add("transform-none");
        document.getElementById("txt-nuevo-evento").classList.add("d-none");
        document.getElementById("txt-cerrar").classList.remove("d-none");
        document.getElementById("btnCrearEvento").classList.add("bg-color-cerrar");*/
    }

    const eliminarUnion = (option) => {
        setMany({
            uniones: state.uniones.filter(item => item.value !== option.value),
            unionEliminada: option
        });
    }

    function agregarUnion(badge) {
        const prev = state.uniones;

        if (badge.label === "Todas") {
            setMany({
                uniones: [badge],
                unionEliminada: prev
            });
            return;
        }

        const next = [...prev.filter(item => item.label !== "Todas"), badge];
        const tieneTodas = prev.some(item => item.label === "Todas");

        setMany({
            uniones: next,
            unionEliminada: tieneTodas ? prev.find(item => item.label === "Todas") : null
        });
    }

    return (
        <>  <ContainerAdminN id={"containerCrear"} className={`transition-all-1s shadowAdmin ${show ? "transform-none" : ''}`} mainContent={
            <>
                <EncabezadoAdmin subtitulo={'Ingrese los datos del evento que desea crear'} titulo={state.isEdit ? 'Editar evento' : 'Crear evento'} />
                {Boolean(state.empresasInscriptas.length > 0 || evento?.cantidadDeMesas) && (
                    <div className='col-12 offset-sm-1 col-sm-10 mb-5'>
                        {Boolean(evento?.cantidadDeMesas) && <BtnGuardarEdit zona={0} text={"Imprimir mesas"} className={"w-auto d-inline-block me-4"}
                            guardar={() => imprimirSeccion({
                                width: "1000px", height: "1500px", idSeccion: "imprimirMesas", printFooter: false
                            })} />}
                        {state.empresasInscriptas.length > 0 && <BtnGuardarEdit zona={0} className={"w-auto d-inline-block"} text={"Imprimir gafetes"}
                            guardar={() => imprimirSeccion({
                                width: "900px", height: "500px", idSeccion: "imprimirGafetes", printFooter: false
                            })} />}
                    </div>)
                }
                <div id="datosEmpresa">
                    <div className='row'>
                        <FormInput id={"nombreEvento"} text={"Nombre del evento"} type={"text"} className={"col-12 offset-sm-1 col-sm-10"}
                            value={state.nombre} setValue={(val) => setField("nombre", val)} />
                    </div>
                    <div className='row '>
                        <div className='col-12 offset-sm-1 col-sm-10'>
                            <div class="mb-3">
                                <label for='uniones' class="form-label letraDatos">Uniones permitidas</label>

                                <SelectFiltrado agregarRubro={agregarUnion} option={state.unionEliminada} url={"empresa/getAllUnionesIndustriales"}
                                    placeholder={"Uniones"} reload={state.reloadCount} />
                                <BadgesUsadas badges={state.uniones} funcion={eliminarUnion} />
                            </div>
                        </div>
                    </div>
                    {state.uniones.length > 0 &&
                        <>
                            <div className='row pb-4 pt-2'>
                                <FormInput id={"empresasLimitadas"} text={"Seleccionar empresas invitadas"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"} idSeccion={4}
                                    value={state.haveInvitedEnterprises} setValue={(val) => setField("haveInvitedEnterprises", val)} />
                            </div>
                            {state.haveInvitedEnterprises &&
                                <div className='row pb-5'>
                                    <BtnGuardarEdit zona={0} className={" offset-sm-1 w-auto"} guardar={mostrarInvitados} text={"Seleccionar empresas"} />
                                    <div className=' col align-self-center'>{state.empresasInvitadas.length} empresas invitadas</div>
                                </div>
                            }</>
                    }
                    <div className='row'>
                        <FormInput id={"fechaEvento"} text={"Fecha"} type={"number"} className={"col-md col-12 offset-sm-1 col-sm-10 "}
                            idSeccion={5} setFecha={(val) => setField("fecha", val)} fecha={state.fecha} fechaInicial={state.fecha} restart={state.restart} isSetDate={state.isSetDate} />
                        <FormInput id={"fechaFinInscripcion"} text={"Fecha de cierre de inscripción"} type={"number"}
                            className={"col-md col-12 offset-md-0 offset-sm-1 col-sm-10 "} idSeccion={5} setFecha={(val) => setField("fechaCierreInscripcion", val)}
                            fecha={state.fechaCierreInscripcion} isSetDate={state.isSetDate} restart={state.restart} />
                        <div className='col-1'></div>
                    </div>
                    <div className='row'>
                        <FormInput id={"horaInicio"} text={"Hora de inicio"} className={"col-md col-12 offset-sm-1 col-sm-10"}
                            idSeccion={3} hora={state.horaInicio} setHora={(val) => setField("horaInicio", val)} disabled={state.isEdit} />
                        <FormInput id={"horaFin"} text={"Hora de fin"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0"}
                            idSeccion={3} hora={state.horaFin} setHora={(val) => setField("horaFin", val)} disabled={state.isEdit} />
                        <div className='col-1'></div>
                    </div>
                    <div className='row  pt-2'>
                        <FormInput id={"rondaNegocios"} text={"¿Es una ronda de negocios?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"} idSeccion={4}
                            value={state.esRondaNegocios} setValue={(val) => setField("esRondaNegocios", val)} disabled={state.isEdit} />
                    </div>
                    {state.esRondaNegocios &&
                        <>
                            <div className='row pt-4'>
                                <FormInput id={"duracionReunion"} text={"Tiempo de reunión (minutos)"} type={"number"} className={"col-md col-12 offset-sm-1 col-sm-10 "}
                                    disabled={!state.esRondaNegocios || state.isEdit} setValue={(val) => setField("duracionReunion", val)} value={state.duracionReunion} />
                                <FormInput id={"duracionEntreReunion"} text={"Tiempo entre reuniones (minutos)"} type={"number"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0"}
                                    disabled={!state.esRondaNegocios || state.isEdit} setValue={(val) => setField("duracionEntreReunion", val)} value={state.duracionEntreReunion} />
                                <div className='col-1'></div>
                            </div>
                            <div className='row'>
                                <FormInput id={"cantMesas"} text={"Cantidad de mesas"} type={"number"} className={"col-md offset-sm-1 col-sm-10 "}
                                    disabled={!state.esRondaNegocios || state.isEdit} setValue={(val) => setField("cantMesas", val)} value={state.cantMesas} />
                                <FormInput id={"cantMesasReservadas"} text={"Cantidad de mesas reservadas"} type={"number"} className={"col-md offset-sm-1 col-sm-10 offset-md-0"}
                                    disabled={!state.esRondaNegocios || state.isEdit} setValue={(val) => setField("cantMesasReservadas", val)} value={state.cantMesasReservadas} />
                                <div className='col-1'></div>
                            </div>
                            <div className='row pb-4 pt-2'>
                                <FormInput id={"poseeBreak"} text={"¿Posee breaks?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"}
                                    idSeccion={4} value={state.poseeBreak} setValue={(val) => setField("poseeBreak", val)} disabled={!state.esRondaNegocios || state.isEdit} />
                            </div>
                            {state.poseeBreak &&
                                <>
                                    {state.breaks.map((b, index) => (
                                        <div className="row mb-3" key={index}>
                                            <div className='col offset-sm-1 row ps-sm-0'>
                                                <FormInput
                                                    id={`horaInicioBreak-${index}`}
                                                    text="Hora de inicio del break"
                                                    className="col-md col-12 "
                                                    idSeccion={3}
                                                    hora={b.horaInicio}
                                                    setHora={(valor) => actualizarBreak(index, "horaInicio", valor)}
                                                    disabled={!state.esRondaNegocios || !state.poseeBreak || state.isEdit}
                                                />
                                                <FormInput
                                                    id={`horaFinBreak-${index}`}
                                                    text="Hora de fin del break"
                                                    className="col-md col-12  "
                                                    idSeccion={3}
                                                    hora={b.horaFin}
                                                    setHora={(valor) => actualizarBreak(index, "horaFin", valor)}
                                                    disabled={!state.esRondaNegocios || !state.poseeBreak || state.isEdit}
                                                />
                                            </div>
                                            <div className='col-1 align-self-md-center mb-4 mt-2 mt-md-0'>
                                                {index > 0 && !state.isEdit &&
                                                    <img src={cruzCierre} className='cursor-pointer filter-mobile-none imgBlack'
                                                        alt="Eliminar" onClick={() => eliminarBreak(index)} />
                                                }
                                            </div>
                                        </div>
                                    ))}
                                    {!state.isEdit &&
                                        <div className='row'>
                                            <BtnGuardarEdit zona={0}
                                                className={"col text-end pb-5"} guardar={agregarBreak} text={"Agregar Break"} />
                                            <div className='col-1 d-none d-sm-block'></div>
                                        </div>}
                                </>
                            }
                            <div className='row pb-4 pt-2'>
                                <FormInput id={"mostrarReuniones"} text={"¿Mostrar reuniones antes del evento?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"}
                                    value={state.mostrarReuniones} setValue={(val) => setField("mostrarReuniones", val)} idSeccion={4} disabled={!state.esRondaNegocios} />
                                <FormInput id={"generarReuniones"} text={"¿Generar reuniones en turnos vacios de forma automática?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"}
                                    value={state.generarReuniones} setValue={(val) => setField("generarReuniones", val)} idSeccion={4} disabled={!state.esRondaNegocios} />
                                <FormInput id={"permitirElegirHorario"} text={"¿Permitir que los inscriptos elijan cuándo ingresar y cuándo retirarse?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"}
                                    value={state.permitirElegirHorario} setValue={(val) => setField("permitirElegirHorario", val)} idSeccion={4} disabled={!state.esRondaNegocios} />
                                <FormInput id={"noMostrarSoloConcretadas"} text={"¿Mostrar reuniones no concretadas, invitaciones recibidas e invitaciones enviadas?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"}
                                    value={state.noMostrarSoloConcretadas} setValue={(val) => setField("noMostrarSoloConcretadas", val)} idSeccion={4} disabled={!state.esRondaNegocios} />
                            </div>
                        </>
                    }
                    <div className='row pb-4 pt-2'>
                        <FormInput id={"aprobarEmpresas"} text={"¿Las empresas tienen que ser aprobadas?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"} idSeccion={4}
                            value={state.aproveEnterprises} setValue={(val) => setField("aproveEnterprises", val)} />
                        {state.aproveEnterprises &&
                            <FormInput id={"eventoPago"} text={"¿El evento es de pago?"} className={"col-md-10 col-12 offset-sm-1 col-sm-10"} idSeccion={4}
                                value={state.isPaymentEvent} setValue={(val) => setField("isPaymentEvent", val)} />
                        }
                    </div>
                    {state.isPaymentEvent &&
                        <div className='row pb-4 '>
                            <FormInput id={"precio"} text={"Precio"} type={"number"} className={"col-md offset-sm-1 col-sm-10 "}
                                setValue={(val) => setField("price", val)} value={state.price} />
                            <FormInput id={"cbu"} text={"CBU / CVU"} type={"number"} className={"col-md offset-sm-1 col-sm-10 offset-md-0"}
                                setValue={(val) => setField("cbu", val)} value={state.cbu} />
                            <FormInput id={"whatsapp"} text={"WhatsApp"} type={"number"} className={"col-md offset-sm-1 col-sm-10 offset-md-0"}
                                setValue={(val) => setField("whatsapp", val)} value={state.whatsapp} />
                            <div className='col-1'></div>
                        </div>
                    }
                    <div className='row'>
                        <FormInput id={"cupoRadio"} text={"Cupo máximo"} className={"col-md offset-sm-1 col-sm-10"} idSeccion={6} value={state.tipoCupo}
                            opcionesText={state.esRondaNegocios ? ['Doble de la cantidad de mesas', 'Ilimitado', 'Ingrese su cupo'] :
                                ['Ilimitado', 'Ingrese su cupo']} setValue={(val) => setField("tipoCupo", val)} />
                        <div className='align-self-center col-md offset-sm-1 offset-md-0 col-sm-10 mt-4 mt-md-0'>

                            <label class={"form-label letraDatos" + (state.tipoCupo === "Ingrese su cupo" || !state.esRondaNegocios ? ' d-none' : '')}>Advertencia</label>
                            <FormInput id={"cupo"} text={"Ingrese el cupo máximo"} type={"number"} className={state.tipoCupo !== 'Ingrese su cupo' ? "d-none" : ''}
                                setValue={(val) => setField("cupo", val)} value={state.cupo} />
                            <div className={state.tipoCupo !== "Doble de la cantidad de mesas" ? ' d-none' : 'form-text'}>
                                Permite una duración del evento de hasta {duracionEvento(state.duracionReunion, state.duracionEntreReunion, state.cantMesas)}
                            </div>
                            <div className={state.tipoCupo !== "Ilimitado" || !state.esRondaNegocios ? ' d-none form-text' : 'form-text'}>Pueden quedar empresas sin reuniones en algunos turnos</div>

                        </div>
                        <div className='col-1'></div>
                    </div>
                    <div className='row pt-4 '>
                        <FormInput id={"direccionRadio"} text={"Dirección"} className={"col-md offset-sm-1 col-sm-10"} idSeccion={6} value={state.typeAddress}
                            opcionesText={['Av. Mitre 4686, Caseros', 'Virtual', 'Otra']} setValue={(val) => setField("typeAddress", val)} />
                        <div className='align-self-center col-md offset-sm-1 offset-md-0 col-sm-10 mt-4 mt-md-0'>
                            <FormInput id={"direccion"} text={"Ingrese la dirección"} type={"text"} className={state.typeAddress !== 'Otra' ? "d-none" : ''}
                                setValue={(val) => setField("direccion", val)} value={state.direccion} />
                        </div>
                        <div className='col-1'></div>
                    </div>
                </div>
                <BtnGuardarEdit zona={0} className={"row text-center py-5"} guardar={crearEvento} text={state.isEdit ? 'Guardar cambios' : "Crear evento"} />
            </>}
        />
            <EmpresasInvitadas uniones={state.uniones} evento={evento} nombreBuscar={nombreBuscar} empresasInvitadas={state.empresasInvitadas}
                funciones={{
                    setEmpresasInvitadas: (val) => {
                        if (typeof val === "function") {
                            setField("empresasInvitadas", val(state.empresasInvitadas));
                        } else {
                            setField("empresasInvitadas", val);
                        }
                    }, setPerfil: setPerfil, setIdElemSeleccionado: setIdElemSeleccionado,
                    updateHandlerRef: updateHandlerRef,
                    setSelectedCompany: setSelectedCompany
                }} show={showedModals.includes('invited')} />
            {Boolean(evento?.cantidadDeMesas) && <ImprimirMesasGafetes cantidadMesas={evento.cantidadDeMesas} />}
            {state.empresasInscriptas.length > 0 && <ImprimirMesasGafetes inscriptos={state.empresasInscriptas} />}
        </>
    );
}